/*
 * Project: forca
 * File Created: Wednesday, 22nd December 2021 10:40:00 am
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import { EmployeeInfoBlockProps } from './employeeInfoBlock.definition';

export const EmployeeInfoBlock = (props: EmployeeInfoBlockProps) => {
	const { anchorName, name, image, headline, phoneNumber, mobilePhoneNumber, emailAddress } = props;

	return (
		<div className="base-band">
			<div className="row">
				<div className="columns">
					<section className="employeeinfo-box">
						<a id={ !anchorName ? name : anchorName } />
						<div className="row collapse">
							<div className="columns small-4 medium-4 large-4">
								{ image && (
									<img src={ image } alt={ name } />
								) }
							</div>
							<div className="columns small-8 medium-8 large-8 end">
								<div className="employeeinfo-box__content">
									{ headline && (
										<h4 className="employeeinfo-box__title">
											{ headline }
										</h4>
									) }

									<p>
										{ name && (
											<span className="employeeinfo-box__name">
												{ name }
											</span>
										) }
										{ phoneNumber && (
											<span className="employeeinfo-box__phone" data-prefix="Direkte: ">
												{ phoneNumber }
											</span>
										) }
										{ mobilePhoneNumber && (
											<span className="employeeinfo-box__mobilephone" data-prefix="Mobil: ">
												{ mobilePhoneNumber }
											</span>
										) }
									</p>

									{ emailAddress && (
										<p>
											<a className="arrow-text-link employeeinfo-box__email" data-encoded-email={ emailAddress }>
												{ emailAddress }
											</a>
										</p>
									) }
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	);
};

export default EmployeeInfoBlock;